import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FactoringOperationsService } from '../../files-clients/service/factoring-operations.service';
import { FactoringCalculationResultViewModel, FactoringCalculationViewModel, FactoringOperationDetailDTO, RecalculateInvoiceOperationDTO } from '../../files-clients/interface/invoice-operation.interface';
import { finalize, map } from 'rxjs';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-invoice-operation-modal',
  templateUrl: './update-invoice-operation-modal.component.html',
  styleUrls: ['./update-invoice-operation-modal.component.scss']
})
export class UpdateInvoiceOperationModalComponent implements OnInit{

  public isLoading: boolean = false;
  public factoringOperation: FactoringCalculationViewModel | null;
  public factoringCalculateResult: FactoringCalculationResultViewModel | null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: bigint,
    private dialogRef: MatDialogRef<UpdateInvoiceOperationModalComponent>,
    private factorigService: FactoringOperationsService
  ) {
  }

  ngOnInit(): void {
    this.getCurrentOperation(this.data);
  }

  getCurrentOperation(id: bigint){ 
    this.isLoading = true;
    this.factorigService.getFactoringOperationById(id)
    .pipe(
      map(apiResponse => {
        return this.getCalculationOperation(apiResponse);
      }),
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: (value) => {
        this.factoringOperation = value;
      }
    })
  }

  private getCalculationOperation(invoiceOperation: FactoringOperationDetailDTO){
    const invoiceCalculation: FactoringCalculationViewModel = {
      invoiceId: invoiceOperation.invoiceId,
      operationCost : invoiceOperation.operationalCost,
      downPaymentPercentage: invoiceOperation.downPaymentPercentage,
      rate: invoiceOperation.rate,
      plazo: invoiceOperation.plazo
    };
    return invoiceCalculation;
  }

  receiveInvoiceOperationCalculation(invoiceOperationCalculation: FactoringCalculationResultViewModel | null): void {
    this.factoringCalculateResult = invoiceOperationCalculation;
  }

  updateInvoiceOperation() {
    const {rate, downPaymentPercentage, plazo, operationalCost} = this.factoringCalculateResult;
    const request: RecalculateInvoiceOperationDTO = {
      rate: rate,
      downPaymentPercentage: downPaymentPercentage,
      plazo: plazo,
      operationalCost: operationalCost
    };
    Swal.fire({
      text: 'Se están actualizando los datos de la operación',
      icon: 'info',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.factorigService.recalculateInvoiceOperation(this.data, request)
        .subscribe({
          next: (response) => {
            this.showSuccess(response);
          },
          error: (err)=> {
            this.showErrorMessage(err.error);
          }
        });
      }
    })
  }

  private showSuccess(response: ActionResponseDTO<any>){
    Swal.fire({
      text: response.resultMessage,
      icon: 'success',
      confirmButtonText: 'Cerrar',
      allowOutsideClick: false
    }).then(n => {
      if(n.isConfirmed) this.closeDialog();
    })
  }

  private showErrorMessage(response: ActionResponseDTO<any>) {
    Swal.fire({
      text: response.resultMessage || 'No fue posible actualizar la operación',
      icon: 'error',
      confirmButtonText: 'Cerrar',
      allowOutsideClick: false
    });
  }

  closeDialog(){
    this.dialogRef.close();
  }
}
